import { Divider, Heading, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ListItemCard } from '../../ListItemCard';

interface Props {
  items: string[];
}

export function Included({ items }: Props) {
  const { t } = useTranslation('experience', { keyPrefix: 'details.included' });

  return (
    <>
      <Divider />

      <VStack w="100%" spacing={5} alignItems="flex-start">
        <Heading>{t('title')}</Heading>

        <VStack w="100%" spacing="10px">
          {
            items.map((item, i) => (
              <ListItemCard key={i} icon="squareRoundedCheck" colorScheme="teal.400" content={item} />
            ))
          }
        </VStack>
      </VStack>
    </>
  );
}